<template>
  <div id="hub">
    <Filters />
    <List />
  </div>
</template>

<script>
import Filters from "./Filters.vue";
import List from "./List.vue";

export default {
  name: "Hub",
  components: {
    Filters,
    List,
  },
  created() {
    if (window.lp_hub_data.current_post_type) {
      const post_type = window.lp_hub_data.current_post_type;

      let postTypeName = this.$store.getters.getPostTypeName(post_type);

      if (postTypeName) {
        this.$store.commit("ADD_POSTTYPE", [postTypeName, post_type]);
      }
    }

    if (window.lp_hub_data.current_tag) {
      const tag = window.lp_hub_data.current_tag;

      let tagName = this.$store.getters.getTagName(tag);

      if (tagName) {
        this.$store.commit("ADD_TAG", [tagName, tag]);
      }
    }

    this.$store.dispatch("newRequest");
  },
};
</script>
